import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
// import {FormStore} from "../../stores/FormStore";
// import {debounce} from 'lodash';
import {api} from "../../api";
import {IWindow} from "../../index";
import {Field} from "../form/Field";
import {Col, Row} from "reactstrap";
import {Select} from "../form/fields/Select";

const IWindow: IWindow = (window as IWindow);

export class ResultSummaryFormData {
    @observable name = '';
}

export class ResultSummaryForm extends CrudForm {
    modelName = 'ResultSummary';

    renderFields() {
        return (
            <>

            </>
        );
    }
}

export class ResultSummaryFilterForm {
    @observable name = '';
    @observable election_id = null;
    @observable election_position_id = null;
    @observable user_party_id = IWindow.initialState.user.party_id;
    @observable party_id = null;
    @observable candidate_id = null;
    @observable level = null;
    @observable state_id = null; 
    @observable senatorial_district_id = null;
    @observable federal_constituency_id = null;
    @observable local_government_area_id = null;
    @observable state_constituency_id = null;
    @observable ward_id = null;
    @observable election_polling_unit_id = null;
    @observable page = null;
}

export class ResultSummaryList extends CrudList {
    modelName = 'ResultSummary';
    defaultSortColumn = 'position_id';
    defaultSortDirection = 'asc';
    @observable is_load_done_election: string = 'n';
    @observable is_load_done: string = 'n';
	
    @observable fraud_yes_no: string = 'NO';
	
	 showSubmitButton = false;
    @observable party_candidates: [];
    @observable candidate_by_position: any = [];
	@observable totalVotes: any = [];
    @observable other_party_candidates: any = [];
	@observable is_admin = IWindow.initialState.user.user_type;
    @observable electionSubscription = {
        registeredVoters : 0,
        registeredVotersPollingUnit : 0,
        accreditedVoters : 0,
        rejectedVoters   : 0,
        disputedVoters   : 0,
        election_polling_unit : 0,
        election_polling_unit_subscriptions : 0,
        election_unsubscribed_polling_unit : 0,
        federal_constituencies: 0,
        local_government_areas: 0,
        senatorial_districts: 0,
        state_constituencies: 0,
        states: 0,
        wards: 0,
        incidence_count: 0,
        election_candidates_votes: [],
        pollingUnitName: [],
        pollingUnitCode: [],
        pollingUnitState: [],
        total_votes: 0,
        grandTotal: [],
        election_positions: [],
        check_list_count: [],
       
    };
    @observable check_lists: any = [];
//	private filters: any = null;
	
	 onChangePosition = (position: any) => {
        this.candidate_by_position = this.electionSubscription.election_candidates_votes.filter((candidate: any) => {
            return candidate.position_id === position;
        }).map((candidate: any) => {
            return {
                label: candidate.name,
                value: candidate.votes
            };
        });
    };
	
	/* loadMoreData(props: any, module: any) {
       this.onChangeElection();
    }  */
 
    
	
	onChangeElection = () => {
 
        this.filterFormStore.getValue('election_id') &&
          api.resultSummary.getListAction( {
		  
		  
            election_id: this.filterFormStore.getValue('election_id'),
			party_id: this.filterFormStore.getValue('party_id'), 
			election_position_id: this.filterFormStore.getValue('election_position_id'),
			candidate_id: this.filterFormStore.getValue('candidate_id'),
			state_id: this.filterFormStore.getValue('state_id'),
			senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
			federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
			local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
			state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
			ward_id: this.filterFormStore.getValue('ward_id'),
			election_polling_unit_id: this.filterFormStore.getValue('election_polling_unit_id'),
			 			
			 
			
        }).then((data: any) => {
		
             this.electionSubscription = data;
			 
			 console.log('election subscription - ' + JSON.stringify(this.electionSubscription));
			 console.log('total votes - ' + this.electionSubscription.total_votes);
			 console.log('polling data - ' + this.electionSubscription.pollingUnitName);

			 this.onChangeElectionFraudCalc(); 
			 
             this.party_candidates = data.election_candidates_votes; 
			 //.filter((candidate: any) => {
             //   return candidate.party_id == (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.filterFormStore.getValue('party_id') );
             //});
			 console.log('party candidate - ', JSON.stringify(data.election_candidates_votes));

            this.other_party_candidates = data.election_candidates_votes.filter((candidate: any) => {
                return candidate.party_id !== (IWindow.initialState.user.party_id ? IWindow.initialState.user.party_id : this.filterFormStore.getValue('party_id') );
            });

            if (data.election_positions && data.election_positions.length) {
                this.filterFormStore.setValue('position_id', data.election_positions[0].value);
                this.candidate_by_position = data.election_candidates_votes.filter((candidate: any) => {
                  
                    return candidate.position_id === data.election_positions[0].value;
                }).map((candidate: any) => {
                    return {
                        label: candidate.name,
                        value: candidate.votes
                    };
                });
            }
        }).catch((e:any ) => {  this.party_candidates = [];  } );   
    };
	
	
	
	
	onChangeElectionFraudCalc = () => { 
	
	
		this.fraud_yes_no = "YES";
	
    };
  
  getCandidateRow = (candidate: any,totalvotes: any) => {
        return <tr key={'candidate-row' + candidate.id}>
			
			<td>
                <div className=""> 
				{ 
					candidate.party_logo && candidate.party_logo.url ?
				<img src={candidate.party_logo.url} style={{width: 50, height: 50}}/> :
                                    <img src="https://fakeimg.pl/50x50/"/>                
									}
									</div>
                
            </td>
			
            <td>
                <div className="">
                    {candidate.party_name}
                </div>
            </td>
			<td>
				<div className="">{candidate.name}
                </div>
			</td>
            <td className="text-center">
                <div className="icon-candidates text-success my-1"></div>
                <div className="comp-position">
                    <div className="text-center">
                        <small>{candidate.position_name}</small>
                    </div>
                    <div className="text-center">
                        <small>{candidate.region_name}</small>
                    </div>
                </div>
            </td>
            <td><span className="spnvot" >
			<span className="spnvot spncolor" style={{width: Math.ceil( (candidate.votes / totalvotes) * 100) ? Math.ceil( (candidate.votes / totalvotes) * 100) : 0 + 'px'}}></span>
			</span></td>
			<td className="text-center "  >{ Math.ceil( (candidate.votes / totalvotes) * 100) ? Math.ceil( (candidate.votes / totalvotes) * 100) : 0 } %</td>
			<td className="text-center">
                <div className="comp-votes">
                    <span>{candidate.votes}</span>
                </div>
            </td>
			
			
        </tr>
    };

/*
    renderColumn = (value: any, compareValue: any, columnName: any) => {
        if (columnName == 'federal' &&
            (this.filterFormStore.getValue('local_government_area_id') ||
                this.filterFormStore.getValue('ward_id') ||
                this.filterFormStore.getValue('state_id'))) {
            return value;
        } else if (['state', 'senatorial_district',
                'federal_constituency',
                'state_constituency'].includes(columnName) &&
            (this.filterFormStore.getValue('local_government_area_id') ||
                this.filterFormStore.getValue('ward_id'))) {
            return value;
        } else if (columnName == 'lga' && this.filterFormStore.getValue('ward_id')) {
            return value;
        } else {
            return <span className={value != compareValue ? 'text-danger' : ''}>{value}</span>
        }
    }

    colums() {
        return [
            {
                name: "name",
                label: "Name",
            },
            {
                name: "party_name",
                label: "Party",
            },
            {
                name: "position.name",
                label: "Position",
            },
            {
                name: "pu_count",
                label: "PU Count",
            },
            {
                name: "pu_total_votes",
                label: "PU votes",
            },
            {
                name: "ward_count",
                label: "Ward Count",
            },
            {
                name: "ward_total_votes",
                label: "Ward votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.pu_total_votes, 'ward')}
                        </>
                    )
                }
            },
            {
                name: "lga_count",
                label: "Lga Count",
            },
            {
                name: "lga_total_votes",
                label: "Lga votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.ward_total_votes, 'lga')}
                        </>
                    )
                }
            },
            {
                name: "state_count",
                label: "State Count",
            },
            {
                name: "state_total_votes",
                label: "State votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.lga_total_votes, 'state')}
                        </>
                    )
                }
            },

            {
                name: "federal_total_votes",
                label: "Federal votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.state_total_votes, 'federal')}
                        </>
                    )
                }
            },
            {
                name: "sd_count",
                label: "Sen Des. Count",
            },
            {
                name: "sd_total_votes",
                label: "Sen. Des. votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.lga_total_votes, 'senatorial_district')}
                        </>
                    )
                }
            },
            {
                name: "fc_count",
                label: "Fed. Cons. Count",
            },
            {
                name: "fc_total_votes",
                label: "Fed. Cons. votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.lga_total_votes, 'federal_constituency')}
                        </>
                    )
                }
            },
            {
                name: "sc_count",
                label: "State. Cons. Count",
            },
            {
                name: "sc_total_votes",
                label: "State. Cons. votes",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {this.renderColumn(value, item.ward_total_votes, 'state_constituency')}
                        </>
                    )
                }
            },
        ];
    }

    idColumn() {
        return '';
    }

    actions() {
        return {}
    }
*/
    stateDropDown() {
        return <Col md={2}>
            <Field
                key={'state_id_' + this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('election_id')
                }
                name="state_id"
                placeholder="Select State"
                component={Select}
                loadOptions={() => {
                    return api.state.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.filterFormStore.setValue('senatorial_district_id', null);
                    this.filterFormStore.setValue('federal_constituency_id', null);
                    this.filterFormStore.setValue('local_government_area_id', null);
                    this.filterFormStore.setValue('state_constituency_id', null);
                    this.filterFormStore.setValue('ward_id', null);
					this.onChangeElection();
					
                }}
            />
        </Col>;
    };

    lgaDropDown() {
        return <Col md={2}>
            <Field
                key={'local_government_area_id_' +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('senatorial_district_id') +
                this.filterFormStore.getValue('federal_constituency_id')
                }
                name="local_government_area_id"
                placeholder="Select LGA"
                component={Select}
                loadOptions={() => {
                    return api.localGovernmentArea.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            state_id: this.filterFormStore.getValue('state_id'),
                            senatorial_district_id: this.filterFormStore.getValue('senatorial_district_id'),
                            federal_constituency_id: this.filterFormStore.getValue('federal_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
                onChange={() => {
                    this.filterFormStore.setValue('ward_id', null);
					this.onChangeElection();
                }}
            />
        </Col>;
    };

    wardsDropDown() {
        return <Col md={2}>
            <Field
                key={"ward_id_" +
                this.filterFormStore.getValue('level') +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('state_id') +
                this.filterFormStore.getValue('local_government_area_id') +
                this.filterFormStore.getValue('state_constituency_id') +
                this.filterFormStore.getValue('election_position_id') +
                this.filterFormStore.getValue('user_party_id')
                }
                name="ward_id"
                placeholder="Select Ward"
                component={Select}
                loadOptions={() => {
                    return api.ward.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            state_id: this.filterFormStore.getValue('state_id'),
                            local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
                            state_constituency_id: this.filterFormStore.getValue('state_constituency_id'),
                            election_position_id: this.filterFormStore.getValue('election_position_id'),
                            level: this.filterFormStore.getValue('level'),
                            user_party_id: this.filterFormStore.getValue('user_party_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
				onChange={() => {
					this.onChangeElection();
				}}
            />
        </Col>;
    }
	
	PollingUnitDropDown() {
        return <Col md={2}>
            <Field
                key={"election_polling_unit_id_" +
                this.filterFormStore.getValue('election_id') +
                this.filterFormStore.getValue('local_government_area_id') +
                this.filterFormStore.getValue('ward_id')
                }
                name="election_polling_unit_id"
                placeholder="Select Polling Unit"
                component={Select}
                loadOptions={() => {
                    return api.partyElectionPollingUnit.getListAction({
                        filters: {
                            election_id: this.filterFormStore.getValue('election_id'),
                            local_government_area_id: this.filterFormStore.getValue('local_government_area_id'),
                            ward_id: this.filterFormStore.getValue('ward_id'),
                        }
                    });
                }}
                store={this.filterFormStore}
				onChange={() => {
					this.onChangeElection();
				}}
            />
        </Col>;
    }

    senatorialDistrictDropDown() {
        return  this.filterFormStore.getValue('level') === 'senatorial_district' ?
            <Col md={2}>
                <Field
                    key={'senatorial_district_id_' +
                    // this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="senatorial_district_id"
                    placeholder="Select Senatorial Districts"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.senatorialDistrict.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id'),
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
						this.onChangeElection();

                    }}
                />
            </Col> : '';
    }

    federalConstituencyDropDown() {
        return  this.filterFormStore.getValue('level') === 'federal_constituency' ?
            <Col md={2}>
                <Field
                    key={'federal_constituency_id_' +
                  //  this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="federal_constituency_id"
                    placeholder="Select Federal Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.federalConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
                        this.filterFormStore.setValue('local_government_area_id', null);
						this.onChangeElection();
                    }}
                />
            </Col> : '';
    }

    stateConstituencyDropDown() {
        return this.filterFormStore.getValue('level') === 'state_constituency' ?
            <Col md={2}>
                <Field
                    key={'state_constituency_id_' +
                //    this.filterFormStore.getValue('level') +
                    this.filterFormStore.getValue('state_id') +
                    this.filterFormStore.getValue('election_position_id')
                    }
                    name="state_constituency_id"
                    placeholder="Select State Constituency"
                    component={Select}
                    valueObject={true}
                    loadOptions={() => {
                        return api.stateConstituency.getListAction({
                            filters: {
                                state_id: this.filterFormStore.getValue('state_id'),
                                election_position_id: this.filterFormStore.getValue('election_position_id'),
                                level: this.filterFormStore.getValue('level'),
                                party_id: this.filterFormStore.getValue('user_party_id')
                            }
                        });
                    }}
                    store={this.filterFormStore}
                    onChange={(item: any) => {
                        this.filterFormStore.setValue('ward_id', null);
						this.onChangeElection();
                    }}
                />
            </Col> : '';
    }

    renderTable() {
        if (this.filterFormStore.getValue('election_id')) {
            /* return super.renderTable(); */
			
			return (

            <>
				<div className="col-xl-12 dash-sep-xl-right">
                                        
										<div className="row pt-2">
									
									<div className="col-sm-6 col-xl-3 d-flex flex-column mt-2" key={'inecVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">INEC REGISTERED<br/> VOTERS</div>
											<div className="stat-valuecnt">{this.electionSubscription.registeredVoters}</div>
										</div>
									</div>
									
									
									<div className="col-sm-6 col-xl-2 d-flex flex-column mt-2" key={'registeredVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">REGISTERED<br/> VOTERS</div>
											<div className="stat-valuecnt">{this.electionSubscription.registeredVotersPollingUnit}</div>
										</div>
									</div>
									
									  
									 <div className="col-sm-6 col-xl-3 d-flex flex-column mt-2" key={'accreditedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">ACCREDICTED<br/> VOTERS</div>
											<div className="stat-valuecnt">{this.electionSubscription.accreditedVoters}</div>
										</div>
									</div> 
									
									
									<div className="col-sm-6 col-xl-2 d-flex flex-column mt-2" key={'rejectedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">REJECTED<br/> VOTES</div>
											<div className="stat-valuecnt">{this.electionSubscription.rejectedVoters}</div>
										</div>
									</div> 
										
									<div className="col-sm-6 col-xl-2 d-flex flex-column mt-2" key={'disputedVoters'}>
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center">
											<div className="stat-labelcnt">DISPUTED<br/> VOTES</div>
											<div className="stat-valuecnt">{this.electionSubscription.disputedVoters}</div>
										</div>
									</div> 
									
										
								
								</div>
								
								<div className="row pt-2">&nbsp;</div>
								
								<div className="row pt-2">
								
									<div className="col-sm-3 col-xl-3 d-flex flex-column mt-2" key={'disputedVoters'}  >
										<div className="card stat-cardcnt box-shadow border-0 rounded-0 text-center" style={{display: this.party_candidates && this.party_candidates.length ? 'block' : 'none' }}>
											<div className="stat-labelcnt" style={{backgroundColor: '#ff6961'}}>FRAUD INDICATORS</div>
											<div className="stat-valuecnt">
											
											{
												this.electionSubscription.registeredVoters < this.electionSubscription.registeredVotersPollingUnit ? 'YES' 
												:  
												this.electionSubscription.registeredVotersPollingUnit <= this.electionSubscription.accreditedVoters ? 'YES' 
												: 
												this.electionSubscription.accreditedVoters < this.electionSubscription.total_votes ? 'YES' 
												: 'NO'     
											}<br/>
											
											<small>
											{
											
												this.electionSubscription.registeredVoters < this.electionSubscription.registeredVotersPollingUnit ? 'Inec is less than register voters' 
												:  
												this.electionSubscription.registeredVotersPollingUnit <= this.electionSubscription.accreditedVoters ? 'Register voter less than or equal to accredicted voters' 
												: 
												this.electionSubscription.accreditedVoters < this.electionSubscription.total_votes ? 'Accredicted voter is less than total votes' 
												: '' 
											
											}
											</small>
											</div>
										</div>
									</div> 
								
								
								</div>

								
								<div className="row pt-2">&nbsp;</div>
										
										
									<div className="row pt-2">	
                                        <div className="competitor-list table-responsive"
                                             key={"my-party" + this.filterFormStore.getValue('election_id')}>
                                            <table className="table table-hover border-top bgcolornw">
												<thead>
													<th>Logo</th>
													<th>Party</th>
													<th>Candidate Name</th>
													<th className="text-center">Postions</th>
													<th></th>
													<th className="text-center">%</th>
													<th className="text-center">Votes</th>
												</thead>
                                                <tbody>
													{
													
												
                                                    this.filterFormStore.getValue('election_id') && this.party_candidates &&
                                                    this.party_candidates.length ?
                                                        this.party_candidates.map((candidate: any) => {
                                                            return (
                                                                this.getCandidateRow(candidate,this.electionSubscription.total_votes)
                                                            );
                                                        }, this)
                                                        : <tr>
                                                            <td colSpan={7}>
                                                                <div className="comp-candidate">No Candidates</div>
                                                            </td>
                                                        </tr>
                                                }
												
												<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															
															
															<td colSpan={3} className="text-right" >Total Valid Votes:</td>
															<td className="text-center fotvalue">{ this.party_candidates &&
                                                    this.party_candidates.length ? this.electionSubscription.total_votes : 0 }</td>
														</tr>	
														
														<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															
															
															<td  colSpan={3}  className="text-right">Disputed Votes:</td>
															<td className="text-center fotvalue coldispute">{this.electionSubscription.disputedVoters}</td>
														</tr>

														<tr>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
																														
															
															<td  colSpan={3} className="text-right">Rejected Votes:</td>
															<td className="text-center fotvalue colrej">{this.electionSubscription.rejectedVoters}</td>
														</tr>	

														<tr className="bggrand">
															<td>&nbsp; </td>
															<td>&nbsp; </td>
															<td>&nbsp; </td>
																																													
															<td  colSpan={3} className="text-right">Grand Total:</td>
															<td className="text-center fotvalue">{( this.party_candidates &&
                                                    this.party_candidates.length ?  this.electionSubscription.grandTotal : 0 )}</td>
														</tr>
												
												</tbody>
											</table>
										</div>
									</div>	
				</div>
												
					
			
			</>
			
			);
			
			
        }
        return <>{'Please select election first!'}</>;
    }
	
	
	onLoadElectionsData = () => {
        return api.election.getListAction({
            filters: {
                party_id: IWindow.initialState.user.party_id,
            }
        }).then((data: any) => {
            if (data && data.length) {
                  if(this.is_load_done_election == "n")
				  {
                    this.filterFormStore.setValue('election_id', data[0].id);  
						  this.onChangeElection();	
				  }
				 
            }
            this.is_load_done_election = "y";
            return data;
        });
    };

    onLoadElectionsParty = () => {
        return api.party.getListAction({
            filters: {
                election_id: this.filterFormStore.getValue('election_id'),
                include_competitor_party: 1
            }
        }).then((data: any) => {
            if (data && data.length) {
                if(this.is_load_done == "n")
                    this.filterFormStore.setValue('party_id', data[0].id);
            }
            this.is_load_done = "y";
            return data;
        });
    };

    renderFilters() {
        return (
            <Row className="form-row">
                <Col md={2}>
                    <Field
                         key={'filter-election' + this.filterFormStore.getValue('election_id')}
                        placeholder="Select Election"
                        name="election_id"
                        component={Select} 
                        required={true}
                        loadOptions={this.onLoadElectionsData}
                       /* loadOptions={() => {
                            return api.election.getListAction({
                                filters: {
                                    party_id: IWindow.initialState.user.party_id,
                                }
                            }).then((data: any) => {
                                if (data && data.length) {
                                    this.filterFormStore.setValue('election_id', data[0].id);
                                }
                                return data;
                            });
                        }}*/
                        store={this.filterFormStore}
						onChange={this.onChangeElection}
                    />
                </Col>

                {this.filterFormStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'party_id_' + this.filterFormStore.getValue('election_id')} 
                           
                            name="party_id"
                            placeholder="Select Party"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_id')}
                            required={true}
                          //  loadOptions={this.onLoadElectionsParty}
                              loadOptions={() => {
                                return api.party.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        include_competitor_party: 1
                                    }
                                }).then((data: any) => {
										if (data && data.length) {
										
											 this.onChangeElection();
										}
                                    return data.data;
                                });
                            }} 
                            store={this.filterFormStore}
                            onChange={() => {
                                this.filterFormStore.setValue('candidate_id', null);
								this.onChangeElection();
                            }}
                        />
                    </Col> : ''
                }

                {this.filterFormStore.getValue('election_id') ?
                    <Col md={2}>
                        <Field
                            key={'election_position_id_' +
                            this.filterFormStore.getValue('election_id') +
                            this.filterFormStore.getValue('user_party_id') +
                            this.filterFormStore.getValue('party_id')
                            }
                            name="election_position_id"
                            placeholder="Select Position"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_id')}
                            required={true}
                            loadOptions={() => {
                                return api.electionPosition.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        party_id: IWindow.initialState.user.party_id,
                                        other_party_id: this.filterFormStore.getValue('party_id'),
                                        search_competitor: 1,
                                    }
                                });
                            }}
                            returnObject={true}
                            extraKey={'level'}
                            store={this.filterFormStore}
                            onChange={(item: any) => {
                                this.filterFormStore.setValue('level', null);
                                if (item) {
                                    this.filterFormStore.setValue('level', item.extraKey);
                                }
                                this.filterFormStore.setValue('state_id', null);
                                this.filterFormStore.setValue('senatorial_district_id', null);
                                this.filterFormStore.setValue('federal_constituency_id', null);
                                this.filterFormStore.setValue('local_government_area_id', null);
                                this.filterFormStore.setValue('state_constituency_id', null);
                                this.filterFormStore.setValue('ward_id', null);
								this.onChangeElection();
                            }}
                        />
                    </Col> : ''
                }

                {this.filterFormStore.getValue('election_position_id') ?
                    <Col md={2}>
                        <Field
                            key={'candidate_filter_summary_' +
                         //   this.filterFormStore.getValue('party_id') + '_election_id' +
                            this.filterFormStore.getValue('election_id') + '_election_position_id' +
                            this.filterFormStore.getValue('election_position_id')
                            }
                            name="candidate_id"
                            placeholder="Select Candidate"
                            component={Select}
                            disabled={!this.filterFormStore.getValue('election_position_id')}
                            required={true}
                            loadOptions={() => {
                                return api.candidate.getListAction({
                                    filters: {
                                        election_id: this.filterFormStore.getValue('election_id'),
                                        party_id: this.filterFormStore.getValue('party_id'),
                                        election_position_id: this.filterFormStore.getValue('election_position_id'),
                                    }
                                });
                            }}
                            store={this.filterFormStore}
							onChange={this.onChangeElection} 
                        />
                    </Col> : ''
                }
                { this.filterFormStore.getValue('level')  !== 'polling_unit'?
                    <>
                    {this.stateDropDown()}
                    {this.senatorialDistrictDropDown()}
                    {this.federalConstituencyDropDown()}
                    {this.lgaDropDown()}
                    {this.stateConstituencyDropDown()}
                    {this.wardsDropDown()}
                    {this.PollingUnitDropDown()}
                    </>  : ''
                }

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {/* this.renderSearch() */}
                </Col>
            </Row>
        );
    }
}

export class ResultSummaryPage extends CrudPage {
    modelName = 'ResultSummary';
    actionButton = false;
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/ResultSummaryPage - Copy.tsx